import {useEffect, useState} from "react";
import {useAPIData} from "../context/hooks/useAPIData";
import {SET_POPUP} from "../context/actions/types";
import ErrorIcon from '../assets/icon_error.svg'

export const Popup = () => {
    const data = useAPIData()
    const [active, setActive] = useState(false)

    const displayPopup = () => {
        setActive(true)
        setTimeout(() => {
            setActive(false)
        }, 2000)
    }

    useEffect(() => {
        data.dispatch({
            type: SET_POPUP,
            payload: displayPopup
        })
    }, [])
    return (
        <div id="popup" className={active ? 'showPopup' : ''}>
            <div className="left">
                <img src={ErrorIcon} alt="error" />
            </div>
            <div className="right">
                Username-ul nu a fost găsit.
                <p id="close-popup">×</p>
            </div>
        </div>
    )
}